import React, { useContext, useEffect, useState } from "react";
import { Fetchdata } from "../../hooks/getData";
import SidebarContext from "../../sidebarcontext/SidebarContext";
import { toast } from "react-toastify";
import CasContext from "./CasContext";

function CasState(props) {
  const { appURL } = useContext(SidebarContext);

  const userinfo = JSON.parse(localStorage.getItem("userInfo"));

  const [loading, setLoading] = useState(true);
  const [isSubmit, setIsSubmit] = useState(false);

  const casEndpoint = "https://esnep.com/easyschoolnew/api/admin/cas-input";

  const [academicYearList, setAcademicYearList] = useState([]);
  const [selectAcademicYear, setSelectAcademicYear] = useState(userinfo.AcademicYear || "");

  const [classList, setClassList] = useState([]);
  const [sectionList, setSectionList] = useState([]);
  const [subjectList, setSubjectList] = useState([]);
  const [termList, setTermList] = useState([]);
  const [themeList, setThemeList] = useState([]);
  const [achieveList, setAchieveList] = useState([]);
  const [rankList, setRankList] = useState([]);
  const [casList, setCasList] = useState([]);

  const [selectClass, setSelectClass] = useState("");
  const [selectSection, setSelectSection] = useState("");
  const [selectSubject, setSelectSubject] = useState("");
  const [selectTerm, setSelectTerm] = useState("");
  const [selectTheme, setSelectTheme] = useState("");
  const [selectAchieve, setSelectAchieve] = useState("");
  const [selectRank, setSelectRank] = useState("");
  const [selectDate, setSelectDate] = useState("");

  // Academic Year List
  useEffect(() => {
    getAcademicYearList();
  }, []);

  const getAcademicYearList = () => {
    const params = {
      SchID: userinfo.SchID,
      UserID: "-1",
      DFlag: "SY",
      Flag: "S",
      Type: "POST",
      FetchURL: `${appURL}api/admin/ref-value`,
    };

    Fetchdata(params).then(function (result) {
      if (result.StatusCode === 200) {
        const postResult = result.referencelst ? result.referencelst : [];
        setAcademicYearList(postResult);
      } else {
        setAcademicYearList([]);
      }
    });
  };

  // Class List
  useEffect(() => {
    getClassList();
  }, [selectAcademicYear]);

  const getClassList = () => {
    const params = {
      SchID: userinfo.SchID,
      UserID: userinfo.UserType === "T" ? userinfo.UserID.toString() : "-1",
      DFlag: "C",
      Flag: "S",
      Type: "POST",
      Academicyear: selectAcademicYear,
      FetchURL: `${appURL}api/admin/ref-value`,
    };

    Fetchdata(params).then(function (result) {
      if (result.StatusCode === 200) {
        const postResult = result.referencelst ? result.referencelst : [];
        setClassList(postResult);
      } else {
        setClassList([]);
      }
    });
  };

  // Section List
  useEffect(() => {
    getSectionList();
  }, [selectClass, selectAcademicYear]);

  const getSectionList = () => {
    if (!selectClass) {
      setSectionList([]);
      return;
    }
    const params = {
      SchID: userinfo.SchID,
      UserID: userinfo.UserType === "T" ? userinfo.UserID.toString() : "-1",
      ClassID: selectClass,
      DFlag: "S",
      Flag: "S",
      Type: "POST",
      Academicyear: selectAcademicYear,
      FetchURL: `${appURL}api/admin/ref-value`,
    };

    Fetchdata(params).then(function (result) {
      if (result.StatusCode === 200) {
        const postResult = result.referencelst ? result.referencelst : [];
        setSectionList(postResult);
      } else {
        setSectionList([]);
      }
    });
  };

  // Subject List
  useEffect(() => {
    getSubjectList();
  }, [selectClass, selectSection, selectAcademicYear]);

  const getSubjectList = () => {
    if (!selectClass || !selectSection) {
      setSubjectList([]);
      return;
    }
    const params = {
      SchID: userinfo.SchID,
      UserID: userinfo.UserType === "T" ? userinfo.UserID.toString() : "-1",
      ClassID: selectClass,
      SectionID: selectSection,
      DFlag: "SB",
      Flag: "S",
      Type: "POST",
      Academicyear: selectAcademicYear,
      FetchURL: `${appURL}api/admin/ref-value`,
    };

    Fetchdata(params).then(function (result) {
      if (result.StatusCode === 200) {
        const postResult = result.referencelst ? result.referencelst : [];
        setSubjectList(postResult);
      } else {
        setSubjectList([]);
      }
    });
  };

  // Term List
  useEffect(() => {
    getTermList();
  }, [selectAcademicYear]);

  const getTermList = () => {
    const params = {
      SchID: userinfo.SchID,
      Flag: "TERM",
      AuthCode: userinfo.AuthCode,
      UserID: userinfo.UserID,
      AcadID: selectAcademicYear,
      Type: "POST",
      FetchURL: casEndpoint,
    };

    Fetchdata(params).then(function (result) {
      if (result.StatusCode === 200) {
        const postResult = result.MarksInputLst ? result.MarksInputLst : [];
        setTermList(postResult);
      } else {
        setTermList([]);
      }
    });
  };

  // Theme List
  useEffect(() => {
    getThemeList();
  }, [selectClass, selectSection, selectSubject, selectTerm, selectAcademicYear]);

  const getThemeList = () => {
    if (!selectClass || !selectSection || !selectSubject || !selectTerm) {
      setThemeList([]);
      return;
    }
    const params = {
      SchID: userinfo.SchID,
      Flag: "THEME",
      AuthCode: userinfo.AuthCode,
      SectionID: selectSection,
      UserID: userinfo.UserID,
      ClassID: selectClass,
      AcadID: selectAcademicYear,
      TermID: selectTerm,
      SubjectID: selectSubject,
      Type: "POST",
      FetchURL: casEndpoint,
    };

    Fetchdata(params).then(function (result) {
      if (result.StatusCode === 200) {
        const postResult = result.MarksInputLst ? result.MarksInputLst : [];
        setThemeList(postResult);
      } else {
        setThemeList([]);
      }
    });
  };

  // Achievement List
  useEffect(() => {
    getAchieveList();
  }, [selectTheme, selectAcademicYear]);

  const getAchieveList = () => {
    if (!selectTheme) {
      setAchieveList([]);
      return;
    }
    const params = {
      SchID: userinfo.SchID,
      Flag: "ACHIEVE",
      AuthCode: userinfo.AuthCode,
      UserID: userinfo.UserID,
      AcadID: selectAcademicYear,
      ClassID: selectClass,
      ThemeID: selectTheme,
      Type: "POST",
      FetchURL: casEndpoint,
    };

    Fetchdata(params).then(function (result) {
      if (result.StatusCode === 200) {
        const postResult = result.MarksInputLst ? result.MarksInputLst : [];
        setAchieveList(postResult);
      } else {
        setAchieveList([]);
      }
    });
  };

  // Rank List
  useEffect(() => {
    getRankList();
  }, [selectAcademicYear]);

  const getRankList = () => {
    const params = {
      SchID: userinfo.SchID,
      Flag: "RANK",
      AuthCode: userinfo.AuthCode,
      UserID: userinfo.UserID,
      AcadID: selectAcademicYear,
      Type: "POST",
      FetchURL: casEndpoint,
    };

    Fetchdata(params).then(function (result) {
      if (result.StatusCode === 200) {
        const postResult = result.MarksInputLst ? result.MarksInputLst : [];
        setRankList(postResult);
      } else {
        setRankList([]);
      }
    });
  };

  // CAS List
  useEffect(() => {
    getCasList();
  }, [selectClass, selectSection, selectAchieve, selectDate, selectAcademicYear]);

  const getCasList = () => {
    if (!selectClass || !selectSection || !selectAchieve) {
      setCasList([]);
      setLoading(false);
      return;
    }
    const params = {
      SchID: userinfo.SchID,
      Flag: "CS",
      AuthCode: userinfo.AuthCode,
      UserID: userinfo.UserID,
      ClassID: selectClass,
      SectionID: selectSection,
      AcadID: selectAcademicYear,
      Date: selectDate,
      AchieveID: selectAchieve,
      Type: "POST",
      FetchURL: casEndpoint,
    };

    Fetchdata(params).then(function (result) {
      if (result.StatusCode === 200) {
        const postResult = result.MarksInputLst ? result.MarksInputLst : [];
        setLoading(false);
        setCasList(postResult);
      } else {
        setLoading(false);
        setCasList([]);
      }
    });
  };

  // CAS Input (Save)
  const saveCas = (param) => {
    const dataForm = {
      SchID: userinfo.SchID,
      Flag: "CI",
      AuthCode: userinfo.AuthCode,
      UserID: userinfo.UserID,
      ClassID: selectClass,
      SectionID: selectSection,
      TermID: selectTerm,
      SubjectID: selectSubject,
      AcadID: selectAcademicYear,
      Date: selectDate,
      ThemeID: selectTheme,
      AchieveID: selectAchieve,
      Param: param,
      Type: "POST",
      FetchURL: casEndpoint,
    };

    Fetchdata(dataForm).then(function (result) {
      if (result.StatusCode === 200) {
        getCasList();
        toast.success(result.Message || "Saved successfully");
      } else {
       toast.error(result.Message || "Save failed");
      }
    });
  };

  return (
    <CasContext.Provider
      value={{
        loading,
        setLoading,
        isSubmit,
        setIsSubmit,
        academicYearList,
        setAcademicYearList,
        selectAcademicYear,
        setSelectAcademicYear,
        classList,
        setClassList,
        sectionList,
        setSectionList,
        subjectList,
        setSubjectList,
        termList,
        setTermList,
        themeList,
        setThemeList,
        achieveList,
        setAchieveList,
        rankList,
        setRankList,
        casList,
        setCasList,
        selectClass,
        setSelectClass,
        selectSection,
        setSelectSection,
        selectSubject,
        setSelectSubject,
        selectTerm,
        setSelectTerm,
        selectTheme,
        setSelectTheme,
        selectAchieve,
        setSelectAchieve,
        selectRank,
        setSelectRank,
        selectDate,
        setSelectDate,
        getAcademicYearList,
        getClassList,
        getSectionList,
        getSubjectList,
        getTermList,
        getThemeList,
        getAchieveList,
        getRankList,
        getCasList,
        saveCas,
      }}
    >
      {props.children}
    </CasContext.Provider>
  );
}

export default CasState;
